import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectCurrentOrgId } from "features/store/orgSlice"
import PowerlinesContent from "widgets/powerlines/PowerlinesContent"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

const Powerlines = () => {
  const { t } = useTranslation()
  const orgId = useSelector(selectCurrentOrgId)

  useDocumentTitle(t("pageTitles.POWERLINES"))

  return <PowerlinesContent key={orgId} />
}

export default Powerlines
